import styled from "styled-components";
import { Subtitle } from "./Heading";
import { generateGreetingsMessage } from "../utils/greetingsMessage";

const Empty = styled.div`
  height: 100%;
  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: center;

  & > span {
    opacity: 0.5;
  }
`;

/**
 * This REact component renders an empty chat interface with a greeting message
 * to welcome the user when they access the chat.
 * 
 * Features:
 * - Displays a greeting message when the chat is empty
 * - Clean and simple chat UI layout
 * 
 * @returns {JSX.Element} A chat interface with an initial greeting message
 */
function EmptyChat() {
  const greetingsMessage = generateGreetingsMessage();
  return (
    <>
      <Empty>
        <Subtitle>{greetingsMessage}</Subtitle>
      </Empty>
    </>
  );
}

export default EmptyChat;